import { Skeleton } from "@mui/material";
import { AtSkeletonProps } from "./at-skeleton.types";

export const AtSkeleton = (props: AtSkeletonProps) => {
  const { variant, width, height } = props;
  return <Skeleton variant={variant} width={width} height={height} />;
};
